export default function UploadInspectionReport() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Upload Inspection Report</h1>
      <p className="text-gray-600">Upload inspection report coming soon...</p>
    </div>
  );
}

